import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import store from './store'
import routes from './routes'
import ElementUI from 'element-ui';
import preview from 'vue-photo-preview';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/reset.css";
import 'vue-photo-preview/dist/skin.css';
import global from './global'

//挂载vue原型链
Vue.prototype.global = global;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(preview);

const router = new VueRouter({
  mode: 'history',
  routes
})


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */  
  let head = document.getElementsByTagName('head');
  let meta = document.createElement('meta');
  meta.name ="viewport";
  meta.content = "width=1314";
  head[0].appendChild(meta);
  window.document.title = to.meta.title == undefined ? '默认标题' : to.meta.title
  next();
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
